import $ from 'cash-dom'


$('.dropdown-menu').each((i, el)=>{
    $(el).prev().on('click', e=>{
        e.preventDefault();
        $(el).toggle();
    });
})
